import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import designImg from "../../assets/images/offerings/design.svg";
import assessmentImg from "../../assets/images/offerings/assessment.svg";
import trainingImg from "../../assets/images/offerings/training.svg";
import { CheckCircle } from "lucide-react";

const offerings = [
  {
    id: "strategic-advisory",
    title: "Strategic Advisory & Design",
    description:
      "We help clients co-create programs, policies, and roadmaps that align with social goals, business values, and community needs.",
    image: designImg,
  },
  {
    id: "evidence-evaluation",
    title: "Evidence & Evaluation",
    description:
      "We generate actionable insights through research and assessments to inform program design, implementation, and scaling.",
    image: assessmentImg,
  },
  {
    id: "monitoring-learning",
    title: "Monitoring & Learning Systems",
    description:
      "We build adaptive M&E systems to enable data-led decision-making and ensure continuous learning and accountability.",
    image: assessmentImg,
  },
  {
    id: "capacity-building",
    title: "Capacity Building",
    description:
      "Our trainings empower NGOs, government bodies, and corporates to improve efficiency, leadership, and innovation.",
    image: trainingImg,
  },
  {
    id: "policy-support",
    title: "Policy & Program Support",
    description:
      "We support policy implementation, localize SDGs, and help strengthen public delivery systems.",
    image: designImg,
  },
];


const OfferingsPreview = () => {
  return (
    <section className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 mb-12">
        {/* Heading centered */}
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary text-center mb-4">
          Our Customized Offerings
        </h2>

        {/* Glass styles */}
        <style>{`
          .glass-card {
            background: linear-gradient(135deg, rgba(255,255,255,0.8), rgba(237,244,255,0.9));
            backdrop-filter: blur(12px) saturate(180%);
            border-radius: 1.5rem;
            border: 1.5px solid rgba(22, 167, 196, 0.2);
            box-shadow: 0 8px 24px rgba(0,0,0,0.05);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .glass-card:hover {
            transform: translateY(-6px) scale(1.03);
            box-shadow: 0 12px 36px rgba(0,0,0,0.1);
          }
        `}</style>

<div className="flex flex-col gap-10">
  {/* Row 1: 3 cards */}
  <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
    {offerings.slice(0, 3).map((offering, index) => (
      <motion.div
        key={offering.id}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: index * 0.2 }}
        className="glass-card p-6 flex flex-col items-center text-center"
      >
          <img
            src={offering.image}
            alt={offering.title}
            className="h-40 mx-auto mb-6 drop-shadow-md pointer-events-none w-full max-w-full"
          />
          <h3 className="text-xl font-semibold text-primary mb-3 font-heading">
            {offering.title}
          </h3>
          <p className="text-sm text-gray-800 px-4 mt-2">{offering.description}</p>

      </motion.div>
    ))}
  </div>

  {/* Row 2: 2 cards centered */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mx-auto">
    {offerings.slice(3).map((offering, index) => (
      <motion.div
        key={offering.id}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: index * 0.2 }}
        className="glass-card p-6 flex flex-col items-center text-center"
      >
          <img
            src={offering.image}
            alt={offering.title}
            className="h-40 mx-auto mb-6 drop-shadow-md pointer-events-none w-full max-w-full"
          />
          <h3 className="text-xl font-semibold text-primary mb-3 font-heading">
            {offering.title}
          </h3>
          <p className="text-sm text-gray-800 px-4 mt-2">{offering.description}</p>
      </motion.div>
    ))}
  </div>
</div>

      </div>
    </section>
  );
};

export default OfferingsPreview;
